import { config } from '../../Config';
import { applyCustomClasses } from '../../utils/applyCustomClasses';

const GetMessagesFromCosmos = async (chatId, userId) => {
    const url = config.getMessages;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ chatId, userId })
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch messages from Cosmos DB: ${response.statusText}`);
        }

        const data = await response.json();
        // Apply custom classes to the content of each message
        const formattedMessages = data.map(msg => {
            if (msg.serverMessage && msg.serverMessage.includes("image_url")) {
                const parsedContent = JSON.parse(msg.serverMessage);
                msg.serverMessage = applyCustomClasses(`<div class="image-wrapper"><img src="${parsedContent.image_url}" alt="Generated Image" class="generated-image"/><a href="${parsedContent.image_url}" download="generated_image.png" class="download-btn">Download</a></div>`);
            } else {
                msg.serverMessage = applyCustomClasses(msg.serverMessage);
            }
            return msg;
        });

        return formattedMessages;
    } catch (error) {
        // console.error('Error fetching messages from Cosmos DB:', error);
        return [];
    }
};

export default GetMessagesFromCosmos;